"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutsideHandler = void 0;
const react_1 = require("react");
function useClickOutsideHandler(wrapperRef, isOpened, setOpened) {
    function handleClickOutside(event) {
        const isClickedOutside = wrapperRef.current && !wrapperRef.current.contains(event.target);
        if (isOpened && isClickedOutside) {
            setOpened(false);
        }
    }
    const handleEscapePress = (event) => {
        if (event.key === "Escape") {
            return handleClickOutside(event);
        }
    };
    (0, react_1.useEffect)(() => {
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            document.addEventListener("click", handleClickOutside, true);
            document.addEventListener("keydown", handleEscapePress);
            return () => {
                document.removeEventListener("click", handleClickOutside, true);
                document.removeEventListener("keydown", handleEscapePress);
            };
        }
        return undefined;
    });
}
exports.useClickOutsideHandler = useClickOutsideHandler;
//# sourceMappingURL=useClickOutsideHandler.js.map